var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-main',[_c('span',{staticClass:"background-image"}),_c('span',{staticClass:"background-filter"}),_c('navBar',{attrs:{"title":"Ares - Main menu","home":true,"accolist":true,"type":"customersuccess"}}),_c('v-row',{attrs:{"dense":""}},[_c('complaints'),_c('rebookings'),_c('damages'),_c('changes'),_c('reviews')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }